import { message } from "antd";

export const messageOpen = message.open;
